import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/icons/map-pin.svg'


const _withScopeId = n => (_pushScopeId("data-v-0908ef33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-person" }
const _hoisted_2 = { class: "space-person-details" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "This user is on the map"
}, null, -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_person_avatar = _resolveComponent("person-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_person_avatar, { user: _ctx.user }, null, 8 /* PROPS */, ["user"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: "user-display-name",
        innerHTML: _ctx.user.DisplayName
      }, null, 8 /* PROPS */, _hoisted_3),
      (_ctx.user.Expertise)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "user-expertise",
            innerHTML: _ctx.user.Expertise
          }, null, 8 /* PROPS */, _hoisted_4))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.user.Location)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "map-pin",
          role: "button",
          title: `Focus ${_ctx.user.FirstName} in the map.`,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('mapIconClicked', _ctx.user)), ["stop"]))
        }, _hoisted_7, 8 /* PROPS */, _hoisted_5))
      : _createCommentVNode("v-if", true)
  ]))
}